import React, { useEffect, useState } from 'react';
import Navbar from '../components/sidebar/Sidebar';
import { Outlet, useNavigate, useParams, useLocation } from 'react-router-dom';
import { InAppCallOverlay } from '../components/AmbientAI/InAppCallOverlay';

const Home = () => {
  const navigate = useNavigate();
  const [initialLoad, setInitialLoad] = useState(true);
  const { refNumber } = useParams();
  const location = useLocation();

  useEffect(() => {
    // Check if the token is present in sessionStorage
    const token = sessionStorage.getItem('authToken');
    const storedCode = sessionStorage.getItem('responseCode');
    console.log('Stored Code:', storedCode);
    console.log('Before Clearing Session Storage:', sessionStorage);
    console.log('token home', token);
    if (!token || storedCode !== '200') {
      sessionStorage.clear(); // Clear session storage
      console.log('After Clearing Session Storage:', sessionStorage);
      navigate('/'); // Redirect to login or desired route
      return;
    }

    // Navigate to the first tab (Teleconsult) only on initial load
    if (initialLoad) {
      navigate('/home/teleconsult'); // Navigate to the first tab's route
      setInitialLoad(false);
    }
  }, [navigate, initialLoad]);
  return (
    <div className="flex min-h-screen bg-background">
      {location.pathname !== `/home/HealthVitals/${refNumber}` && (
        <Navbar />
      )}
      <main className={`flex-grow transition-all duration-300 ${
        location.pathname !== `/home/HealthVitals/${refNumber}` 
          ? "lg:ml-64 mt-16 lg:mt-0" 
          : ""
      }`}>
        <div className="p-4 md:p-8 max-w-7xl mx-auto h-full">
          <Outlet />
        </div>
      </main>

      {/* Global In-App Video Teleconsult Call overlays & controls */}
      <InAppCallOverlay />
    </div>
  );
};

export default Home;
